import { render, staticRenderFns } from "./PaymentMethodButtons.vue?vue&type=template&id=4d6533cb&scoped=true"
import script from "./PaymentMethodButtons.vue?vue&type=script&lang=js"
export * from "./PaymentMethodButtons.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodButtons.vue?vue&type=style&index=0&id=4d6533cb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6533cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d6533cb')) {
      api.createRecord('4d6533cb', component.options)
    } else {
      api.reload('4d6533cb', component.options)
    }
    module.hot.accept("./PaymentMethodButtons.vue?vue&type=template&id=4d6533cb&scoped=true", function () {
      api.rerender('4d6533cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/PaymentMethodButtons.vue"
export default component.exports